const selectorsLogin = {
  recoverPasswordFormTriggers: '[data-recover-toggle]',
  recoverPasswordForm: '[data-recover-form]',
  loginForm: '[data-login-form]',
  formState: '[data-form-state]',
  resetSuccess: '[data-reset-success]',
};

function onShowHidePasswordForm(evt) {
  evt.preventDefault();
  toggleRecoverPasswordForm();
}

function checkUrlHash() {
  const hash = window.location.hash;

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
  console.log('clicked toggle')
  document.querySelector(selectorsLogin.recoverPasswordForm).classList.toggle('hide');
  document.querySelector(selectorsLogin.loginForm).classList.toggle('hide');
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
  // check if reset password form was
  // successfully submitted and show success message.

  if (document.querySelector(selectorsLogin.formState)) {
    document.querySelector(selectorsLogin.resetSuccess).classList.remove('hide');
  }
}

if (document.querySelector(selectorsLogin.recoverPasswordForm)) {
  checkUrlHash();
  resetPasswordSuccess();

  document.querySelectorAll(selectorsLogin.recoverPasswordFormTriggers).forEach((trigger) => {
    trigger.addEventListener('click', onShowHidePasswordForm);
  });
}

/**
Initialize Account Forms
*
*/
/*
function initPristineForms() {
  var forms = document.querySelectorAll(".data-validate-form");

  forms.forEach(form => {
    var pristine = new Pristine(form);
    
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var valid = pristine.validate();

      if(valid) {
        this.submit();
        if(this.getAttribute('data-url')) {
          const formUrl = this.getAttribute('data-url');
          document.location.href = formUrl;  
        }
      }
    });
  })
  

  
}
initPristineForms();
*/

// console.log("i'm hereeeee");
// function showHideForms() {
//   var recoverForm = document.querySelector('[data-recover-form]');
//   var signInForm = document.querySelector('[data-sign-in]')
//   var showRecover = document.querySelectorAll('[data-recover-toggle]');
//   showRecover.forEach(button => {
//     button.addEventListener('click', function() {
//       console.log('clicked med')
//       signInForm.classList.toggle('hide');
//       recoverForm.classList.toggle('hide');
//     })
//   })
  
// }